<template>
  <v-row>
    <v-col cols="12">
      <v-card outlined class="rounded-card">
        <v-subheader>Produtos</v-subheader>
        <v-divider/>
        <v-list>
          <template v-for="(produto, index) in requisicao.produtos">
            <v-list-item :key="produto.id">
              <v-list-item-content>
                <v-list-item-title>
                  <px-situacao-requisicao-icon :situacao="produto.situacao"/>
                  <px-span-tooltip v-if="checkCodigo(produto.produto)"
                                   top
                                   :text="labelCodigo(produto.produto)"
                                   tooltip="Código interno"/>
                  {{ descricaoProduto(produto) }}
                  <px-historico-preco-produto v-if="produto.produto"
                                              small
                                              :produto="produto.produto"
                                              :unidade-medida="produto.unidadeMedida"/>
                </v-list-item-title>
                <v-list-item-subtitle class="mt-1">
                  {{
                    produto.quantidade
                      | number(getCurrencyFormat(casasDecimaisItem(produto)))
                  }}
                  {{ produto.unidadeMedida.descricao }}
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <px-anexo read-only
                          v-model="produto.arquivos"
                          download-base-path="files/download-comprador"/>
              </v-list-item-action>
              <v-list-item-action>
                <px-data-entrega-produto
                  :dataEntrega="produto.dataPrevisaoEntrega"/>
              </v-list-item-action>
              <v-list-item-action>
                <px-detalhes-produto
                  :produto="produto"
                  show-projeto
                  show-centro-custo
                  show-obs-externa
                  show-obs-interna>
                  <template v-slot:bottom>
                    <px-campos-integracao
                      v-if="cadastrosAdicionaisItem(produto) && erpCamposIntegracao"
                      type="requisicao-produtos-view"
                      :form-data="cadastrosAdicionaisItem(produto)"/>
                  </template>
                </px-detalhes-produto>
              </v-list-item-action>
              <v-list-item-action v-if="produto.produto">
                <px-preco-target :produto="produto"/>
              </v-list-item-action>
              <v-list-item-action v-if="hasModuleGerenciaOuRequisicao && !isFinalizada(produto)">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn icon v-on="on" @click="onClickCancel(produto)">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </template>
                  <span>Cancelar produto</span>
                </v-tooltip>
              </v-list-item-action>
              <v-list-item-action v-if="hasModuleGerencia && !isFinalizada(produto)">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn icon v-on="on" @click="onClickFinalizar(produto)">
                      <v-icon>mdi-check</v-icon>
                    </v-btn>
                  </template>
                  <span>Finalizar produto</span>
                </v-tooltip>
              </v-list-item-action>
            </v-list-item>
            <v-divider v-if="index !== (requisicao.produtos.length - 1)"
                       :key="`v-div${produto.id}`"/>
          </template>
        </v-list>
      </v-card>
    </v-col>
    <px-confirm-dialog ref="confirmCancelar"/>
    <px-confirm-dialog ref="confirmFinalizar"/>
  </v-row>
</template>

<script>
import RequisicoesService from '@/modules/requisicao/requisicoes-service';
import { SituacaoRequisicao } from 'px-business-components';
import { mapGetters } from 'vuex';
import { CasaDecimalUtils } from 'px-components';
import { cadastrosAdicionaisToMap } from '@/utils/campos-integracao-utils';

export default {
  props: {
    requisicao: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters('user', ['hasModuleGerencia', 'hasRoleRequisicao', 'erpCamposIntegracao']),
    hasModuleGerenciaOuRequisicao() {
      return this.hasModuleGerencia || this.hasRoleRequisicao;
    },
    descricaoProduto() {
      return item => (item.produto ? item.produto.descricao : item.especificacaoProduto);
    },
    getCurrencyFormat() {
      return item => CasaDecimalUtils.getCurrencyFormat(item);
    },
    isFinalizada() {
      return produto => [SituacaoRequisicao.keys.FINALIZADA.key,
        SituacaoRequisicao.keys.CANCELADA.key].includes(produto.situacao);
    },
    checkCodigo() {
      return item => (item ? item.codigo : null);
    },
    labelCodigo() {
      return item => (item ? `${item.codigo} -` : '');
    },
    casasDecimaisItem() {
      return item => (item.produto ? item.produto.casasDecimais : null);
    },
    cadastrosAdicionaisItem() {
      return (item) => {
        if (!item.cadastrosAdicionais || !item.cadastrosAdicionais.length) {
          return null;
        }
        return cadastrosAdicionaisToMap(item.cadastrosAdicionais);
      };
    },
  },
  methods: {
    emitUpdate() {
      this.$emit('update');
    },
    cancel(produto) {
      RequisicoesService.cancelarProduto(produto.id)
        .then(() => {
          this.$toast('Produto cancelado', { color: 'success' });
          this.emitUpdate();
        });
    },
    onClickCancel(produto) {
      this.$refs.confirmCancelar.open('Você deseja cancelar este produto?',
        'Esta operação não pode ser desfeita',
        { width: 350 })
        .then((confirm) => {
          if (!confirm) {
            return;
          }
          this.cancel(produto);
        });
    },
    finalizar(produto) {
      RequisicoesService.finalizarProduto(produto.id)
        .then(() => {
          this.$toast('Produto cancelado', { color: 'success' });
          this.emitUpdate();
        });
    },
    onClickFinalizar(produto) {
      this.$refs.confirmFinalizar.open('Você deseja finalizar este produto?',
        'Esta operação não pode ser desfeita',
        { width: 350 })
        .then((confirm) => {
          if (!confirm) {
            return;
          }
          this.finalizar(produto);
        });
    },
  },
};
</script>
